// extracted by mini-css-extract-plugin
export default {"content":"TextCell-module__content__qZdym"};